// List of commonly used competitive Pokemon with their base stats, items, and moves
export const COMPETITIVE_POKEMON = [
  {
    name: "Dragapult",
    baseSpeed: 142,
    types: ["Dragon", "Ghost"],
    commonItems: ["Choice Specs", "Choice Scarf", "Life Orb"],
    commonMoves: ["Dragon Darts", "Shadow Ball", "U-turn", "Fire Blast"]
  },
  {
    name: "Chien-Pao",
    baseSpeed: 135,
    types: ["Dark", "Ice"],
    commonItems: ["Heavy-Duty Boots", "Choice Band", "Life Orb"],
    commonMoves: ["Ice Shard", "Crunch", "Sacred Sword", "Sucker Punch"]
  },
  {
    name: "Iron Bundle",
    baseSpeed: 136,
    types: ["Ice", "Water"],
    commonItems: ["Choice Specs", "Choice Scarf", "Life Orb"],
    commonMoves: ["Freeze-Dry", "Hydro Pump", "Ice Beam", "Blizzard"]
  },
  {
    name: "Gholdengo",
    baseSpeed: 84,
    types: ["Steel", "Ghost"],
    commonItems: ["Choice Specs", "Leftovers", "Air Balloon"],
    commonMoves: ["Make It Rain", "Shadow Ball", "Power Gem", "Thunderbolt"]
  },
  {
    name: "Flutter Mane",
    baseSpeed: 135,
    types: ["Ghost", "Fairy"],
    commonItems: ["Choice Specs", "Life Orb", "Focus Sash"],
    commonMoves: ["Shadow Ball", "Moonblast", "Mystical Fire", "Dazzling Gleam"]
  },
  {
    name: "Walking Wake",
    baseSpeed: 109,
    types: ["Water", "Dragon"],
    commonItems: ["Choice Specs", "Life Orb", "Choice Scarf"],
    commonMoves: ["Hydro Steam", "Dragon Pulse", "Flamethrower", "Ice Beam"]
  },
  {
    name: "Iron Valiant",
    baseSpeed: 116,
    types: ["Fairy", "Fighting"],
    commonItems: ["Life Orb", "Focus Sash", "Choice Specs"],
    commonMoves: ["Spirit Break", "Close Combat", "Knock Off", "Swords Dance"]
  },
  {
    name: "Chi-Yu",
    baseSpeed: 100,
    types: ["Dark", "Fire"],
    commonItems: ["Choice Specs", "Life Orb", "Choice Scarf"],
    commonMoves: ["Heat Wave", "Dark Pulse", "Overheat", "Snarl"]
  },
  {
    name: "Roaring Moon",
    baseSpeed: 119,
    types: ["Dark", "Dragon"],
    commonItems: ["Choice Band", "Life Orb", "Heavy-Duty Boots"],
    commonMoves: ["Dragon Claw", "Knock Off", "Earthquake", "Dragon Dance"]
  },
  {
    name: "Iron Moth",
    baseSpeed: 110,
    types: ["Fire", "Poison"],
    commonItems: ["Heavy-Duty Boots", "Choice Specs", "Life Orb"],
    commonMoves: ["Overheat", "Sludge Wave", "Energy Ball", "Air Slash"]
  },
  {
    name: "Dragonite",
    baseSpeed: 80,
    types: ["Dragon", "Flying"],
    commonItems: ["Heavy-Duty Boots", "Leftovers", "Choice Band"],
    commonMoves: ["Dragon Dance", "Extreme Speed", "Earthquake", "Ice Punch"]
  },
  {
    name: "Volcarona",
    baseSpeed: 100,
    types: ["Bug", "Fire"],
    commonItems: ["Heavy-Duty Boots", "Leftovers", "Life Orb"],
    commonMoves: ["Quiver Dance", "Fire Blast", "Bug Buzz", "Giga Drain"]
  },
  {
    name: "Meowscarada",
    baseSpeed: 123,
    types: ["Grass", "Dark"],
    commonItems: ["Choice Band", "Life Orb", "Focus Sash"],
    commonMoves: ["Flower Trick", "Knock Off", "U-turn", "Play Rough"]
  },
  {
    name: "Great Tusk",
    baseSpeed: 87,
    types: ["Ground", "Fighting"],
    commonItems: ["Leftovers", "Rocky Helmet", "Choice Band"],
    commonMoves: ["Headlong Rush", "Close Combat", "Earthquake", "Ice Spinner"]
  },
  {
    name: "Skeledirge",
    baseSpeed: 66,
    types: ["Ghost", "Fire"],
    commonItems: ["Leftovers", "Heavy-Duty Boots", "Choice Specs"],
    commonMoves: ["Torch Song", "Shadow Ball", "Will-O-Wisp", "Flamethrower"]
  },
  {
    name: "Calyrex-Ice Rider",
    baseSpeed: 50,
    types: ["Psychic", "Ice"],
    commonItems: ["Choice Band", "Heavy-Duty Boots", "Weakness Policy"],
    commonMoves: ["Glacial Lance", "High Horsepower", "Close Combat", "Trick Room"]
  },
  {
    name: "Calyrex-Shadow Rider",
    baseSpeed: 150,
    types: ["Psychic", "Ghost"],
    commonItems: ["Choice Specs", "Life Orb", "Focus Sash"],
    commonMoves: ["Astral Barrage", "Draining Kiss", "Psychic", "Nasty Plot"]
  },
  {
    name: "Koraidon",
    baseSpeed: 135,
    types: ["Fighting", "Dragon"],
    commonItems: ["Booster Energy", "Life Orb", "Choice Band"],
    commonMoves: ["Collision Course", "Dragon Claw", "Fire Fang", "Bulk Up"]
  },
  {
    name: "Miraidon",
    baseSpeed: 135,
    types: ["Electric", "Dragon"],
    commonItems: ["Booster Energy", "Life Orb", "Choice Specs"],
    commonMoves: ["Electro Drift", "Dragon Pulse", "Calm Mind", "Thunderbolt"]
  },
  {
    name: "Iron Hands",
    baseSpeed: 50,
    types: ["Fighting", "Electric"],
    commonItems: ["Assault Vest", "Life Orb", "Choice Band"],
    commonMoves: ["Wild Charge", "Close Combat", "Heavy Slam", "Thunder Punch"]
  },
  {
    name: "Scream Tail",
    baseSpeed: 111,
    types: ["Fairy", "Psychic"],
    commonItems: ["Choice Scarf", "Focus Sash", "Life Orb"],
    commonMoves: ["Dazzling Gleam", "Psychic", "Encore", "Perish Song"]
  },
  {
    name: "Kyogre",
    baseSpeed: 90,
    types: ["Water"],
    commonItems: ["Choice Specs", "Life Orb", "Mystic Water"],
    commonMoves: ["Water Spout", "Origin Pulse", "Ice Beam", "Thunder"]
  },
  {
    name: "Groudon",
    baseSpeed: 90,
    types: ["Ground"],
    commonItems: ["Life Orb", "Choice Band", "Soft Sand"],
    commonMoves: ["Precipice Blades", "Heat Crash", "Stone Edge", "Swords Dance"]
  },
  {
    name: "Ho-Oh",
    baseSpeed: 90,
    types: ["Fire", "Flying"],
    commonItems: ["Heavy-Duty Boots", "Life Orb", "Choice Band"],
    commonMoves: ["Sacred Fire", "Brave Bird", "Earthquake", "Recover"]
  },
  {
    name: "Lugia",
    baseSpeed: 110,
    types: ["Psychic", "Flying"],
    commonItems: ["Heavy-Duty Boots", "Leftovers", "Rocky Helmet"],
    commonMoves: ["Aeroblast", "Future Sight", "Recover", "Calm Mind"]
  },
  {
    name: "Lunala",
    baseSpeed: 97,
    types: ["Psychic", "Ghost"],
    commonItems: ["Choice Specs", "Power Herb", "Weakness Policy"],
    commonMoves: ["Moongeist Beam", "Psychic", "Meteor Beam", "Air Slash"]
  },
  {
    name: "Zacian-Crowned",
    baseSpeed: 148,
    types: ["Fairy", "Steel"],
    commonItems: ["Rusted Sword", "Life Orb", "Choice Band"],
    commonMoves: ["Behemoth Blade", "Play Rough", "Close Combat", "Wild Charge"]
  },
  {
    name: "Zamazenta-Crowned",
    baseSpeed: 148,
    types: ["Fighting", "Steel"],
    commonItems: ["Rusted Shield", "Leftovers", "Choice Band"],
    commonMoves: ["Behemoth Bash", "Close Combat", "Iron Head", "Crunch"]
  },
  {
    name: "Urshifu-Rapid-Strike",
    baseSpeed: 97,
    types: ["Fighting", "Water"],
    commonItems: ["Choice Band", "Choice Scarf", "Life Orb"],
    commonMoves: ["Surging Strikes", "Close Combat", "Aqua Jet", "U-turn"]
  },
  {
    name: "Urshifu-Single-Strike",
    baseSpeed: 97,
    types: ["Fighting", "Dark"],
    commonItems: ["Choice Band", "Choice Scarf", "Life Orb"],
    commonMoves: ["Wicked Blow", "Close Combat", "Sucker Punch", "U-turn"]
  },
  {
    name: "Landorus-Incarnate",
    baseSpeed: 101,
    types: ["Ground", "Flying"],
    commonItems: ["Life Orb", "Choice Scarf", "Rocky Helmet"],
    commonMoves: ["Earth Power", "Sludge Wave", "Focus Blast", "Calm Mind"]
  },
  {
    name: "Landorus-Therian",
    baseSpeed: 91,
    types: ["Ground", "Flying"],
    commonItems: ["Choice Scarf", "Rocky Helmet", "Assault Vest"],
    commonMoves: ["Earthquake", "U-turn", "Rock Slide", "Knock Off"]
  },
  {
    name: "Tornadus-Incarnate",
    baseSpeed: 111,
    types: ["Flying"],
    commonItems: ["Life Orb", "Focus Sash", "Choice Specs"],
    commonMoves: ["Bleakwind Storm", "Tailwind", "Taunt", "Heat Wave"]
  },
  {
    name: "Tornadus-Therian",
    baseSpeed: 121,
    types: ["Flying"],
    commonItems: ["Choice Specs", "Life Orb", "Choice Scarf"],
    commonMoves: ["Bleakwind Storm", "Heat Wave", "Taunt", "U-turn"]
  },
  {
    name: "Thundurus-Incarnate",
    baseSpeed: 111,
    types: ["Electric", "Flying"],
    commonItems: ["Life Orb", "Focus Sash", "Choice Specs"],
    commonMoves: ["Thunderbolt", "Sludge Wave", "Taunt", "Nasty Plot"]
  },
  {
    name: "Thundurus-Therian",
    baseSpeed: 101,
    types: ["Electric", "Flying"],
    commonItems: ["Choice Specs", "Life Orb", "Assault Vest"],
    commonMoves: ["Thunderbolt", "Sludge Wave", "Grass Knot", "Volt Switch"]
  },
  {
    name: "Enamorus-Incarnate",
    baseSpeed: 106,
    types: ["Fairy", "Flying"],
    commonItems: ["Life Orb", "Choice Specs", "Focus Sash"],
    commonMoves: ["Dazzling Gleam", "Earth Power", "Mystical Fire", "Calm Mind"]
  },
  {
    name: "Enamorus-Therian",
    baseSpeed: 46,
    types: ["Fairy", "Flying"],
    commonItems: ["Choice Specs", "Weakness Policy", "Life Orb"],
    commonMoves: ["Dazzling Gleam", "Earth Power", "Mystical Fire", "Moonblast"]
  },
  {
    name: "Incineroar",
    baseSpeed: 60,
    types: ["Fire", "Dark"],
    commonItems: ["Assault Vest", "Safety Goggles", "Sitrus Berry"],
    commonMoves: ["Fake Out", "Flare Blitz", "Knock Off", "Parting Shot"]
  },
  {
    name: "Rillaboom",
    baseSpeed: 85,
    types: ["Grass"],
    commonItems: ["Choice Band", "Assault Vest", "Life Orb"],
    commonMoves: ["Grassy Glide", "Wood Hammer", "High Horsepower", "U-turn"]
  },
  {
    name: "Amoonguss",
    baseSpeed: 30,
    types: ["Grass", "Poison"],
    commonItems: ["Rocky Helmet", "Sitrus Berry", "Mental Herb"],
    commonMoves: ["Spore", "Rage Powder", "Pollen Puff", "Clear Smog"]
  }
];

// Speed modifying items and their multipliers
export const SPEED_ITEMS = {
  "Choice Scarf": 1.5,
};

// Speed boosting/lowering natures
export const SPEED_NATURES = {
  "Timid": 1.1,
  "Jolly": 1.1,
  "Naive": 1.1,
  "Hasty": 1.1,
  "Brave": 0.9,
  "Relaxed": 0.9,
  "Quiet": 0.9,
  "Sassy": 0.9
};

// Battle conditions that modify speed
export const SPEED_CONDITIONS = {
  "Tailwind": 2.0,        // Doubles speed for 4 turns
  "Paralysis": 0.5,       // Halves speed when paralyzed
  "Trick Room": -1        // Reverses speed order (represented as -1 for logic handling)
}; 